import { isEditing } from "@/utils/islands";
import { fetcher, getApiUrl } from "@/utils/fetcher-raw";
import {
    clearSession,
    getBearerToken,
    getRefreshToken,
    isAccessTokenExpiringSoon,
    setTokens,
} from "./Store/tokenstore";
import { openLogin } from "./Login/login";
import { refreshLoginState } from "./Login/LoginStateElement";

let refreshPromise: Promise<string | null> | null = null;

async function promptForLogin() {
    if (isEditing()) {
        return;
    }

    if (await openLogin()) {
        document.location.reload();
    }
}

function endExpiredSession(): null {
    clearSession();
    refreshLoginState();
    void promptForLogin();
    return null;
}

async function refreshAccessToken(): Promise<string | null> {
    const refreshToken = getRefreshToken();

    if (!refreshToken) return null;

    const response = await fetcher(getApiUrl() + "/api/authentication/refresh", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({ refreshToken }),
    });


    const body = await response.json().catch(() => null);
    if (!body?.isSuccess || !body.data) {
        return endExpiredSession();
    }

    const { data } = body;
    setTokens(data.bearerToken, data.refreshToken, data.refreshTokenExpiresAtUtc);
    return data.bearerToken;
}

export async function getSilentRefreshedToken(): Promise<string | null> {
    if (isAccessTokenExpiringSoon()) {
        await getRefreshedToken();
    }

    return getBearerToken();
}

export function getRefreshedToken(): Promise<string | null> {
    if (!refreshPromise) {
        refreshPromise = refreshAccessToken().finally(() => {
            refreshPromise = null;
        });
    }
    return refreshPromise;
}